import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseNetworkIcon, ContentWrapper, CustomImage, NetworkIconWrapper, } from './styles';
const AssetNetworkIcon = ({ baseUrl, networkIcon, size = '3rem', className, }) => {
    const secondIcon = typeof networkIcon === 'string' ? (_jsx(CustomImage, { src: networkIcon })) : (networkIcon);
    return (_jsxs(ContentWrapper, { className: className, children: [_jsx(BaseNetworkIcon, { className: "baseNetworkIcon", src: baseUrl, size: size }), !!networkIcon && (_jsx(NetworkIconWrapper, { className: "networkIconWrapper", children: secondIcon }))] }));
};
export default AssetNetworkIcon;
//# sourceMappingURL=AssetNetworkIcon.js.map